export enum CustomPDFReportDesignation {
    DRAFT = 'draft',
    DELIVERABLE = 'deliverable',
}
